'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _alert = require('../../style/alert');

var _alert2 = _interopRequireDefault(_alert);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _l10n = require('../../../../common/l10n');

var _l10n2 = _interopRequireDefault(_l10n);

var _Control = require('../../../Control');

var _Control2 = _interopRequireDefault(_Control);

var _Button = require('../../../Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var titleContent = null,
        _props = this.props,
        needTitle = _props.needTitle,
        title = _props.title,
        buttonLabel = _props.buttonLabel,
        children = _props.children,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$style = _props.style,
        style = _props$style === undefined ? {} : _props$style,
        classList = this.compileStyle(_alert2.default);


    if (needTitle) {
        titleContent = _react2.default.createElement(
            _Control2.default,
            { className: classList.title },
            _l10n2.default.translate(title)
        );
    }

    return _react2.default.createElement(
        'form',
        {
            action: '/',
            method: 'post',
            className: classList.root + ' ' + className,
            onSubmit: this.submit
        },
        titleContent,
        _react2.default.createElement(
            'div',
            { className: classList.content },
            children
        ),
        _react2.default.createElement(
            'div',
            { className: classList.controls },
            _react2.default.createElement(
                'div',
                { className: classList.button },
                _react2.default.createElement(
                    _Button2.default,
                    {
                        primary: true,
                        type: 'submit',
                        style: style.button
                    },
                    _l10n2.default.translate(buttonLabel)
                )
            )
        )
    );
}